<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="admin-config-page" v-if="mounted">
    <div class="vx-row">

      <div class="vx-col md:w-1/2 w-full mb-base">


        <vx-card title="Information">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                    Nom de la ville
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="config.name"/>
            </div>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-button @click="saveForm">Save</vs-button>
            </div>
          </div>


        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Quotas">


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                    Unité de mesure
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">

              <ul class="centerx">
                <li>
                  <vs-radio color="primary" v-model="config.volumeUnit" vs-value="m">m<sup>3</sup></vs-radio>
                </li>
                <li>
                  <vs-radio color="dark" v-model="config.volumeUnit" vs-value="v">v<sup>3</sup></vs-radio>
                </li>
              </ul>
            </div>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                Nombre de visites maximum:
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">

              <vs-switch color="success" v-model="config.quotaVisitsSwitch" name="quotaVisitsSwitch">
                <span slot="on">Illimité</span>
                <span slot="off">Limité</span>
              </vs-switch>

              <vue-slider v-if="!config.quotaVisitsSwitch" :interval="1" :max="50" :min="1" tooltip="hover" v-model="config.quotaVisits"/>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                Volume maximum  {{config.volumeUnit}}<sup>3</sup>
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">

              <vs-switch color="success" v-model="config.quotaVolumeSwitch" name="quotaVolumeSwitch">
                <span slot="on">Illimité</span>
                <span slot="off">Limité</span>
              </vs-switch>

              <vue-slider v-if="!config.quotaVolumeSwitch" :interval="1" :max="100" :min="1" tooltip="hover" v-model="config.quotaVolume"/>
            </div>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-button @click="saveForm">Save</vs-button>
            </div>
          </div>

        </vx-card>
      </div>
    </div>


    <div class="vx-col md:w-1/2 w-full mb-base">
      <vx-card title="Matériaux">


        <div class="vx-row mb-6" v-for="(material , index) of config.quotaMaterials" :key="index">
          <div class="vx-col sm:w-1/3 w-full">
                <span>
                    {{material.name}}
                </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">

            <vs-switch color="danger" v-model="config.quotaMaterials[index].quota">
              <span slot="off">Illimité</span>
              <span slot="on">Limité par quota</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
                <span>
                </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-button @click="saveForm">Save</vs-button>
          </div>
        </div>

      </vx-card>


    </div>
  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import firebase from 'firebase'

  export default {
    components: {
      VueSlider
    },
    data ()
    {
      return {
        mounted: false,

        config: {
          name:           '',
          volumeUnit:     'm',
          quotaVisits:    10,
          quotaVolume:    10,
          quotaMaterials: [],

          quotaVisitsSwitch: true,
          quotaVolumeSwitch: true,
        }
      }
    },
    computed:   {
      activeUserInfo ()
      {
        return this.$store.state.AppActiveUser
      },
      cityConfig ()
      {
        return this.$store.state.cityConfig
      },
      quotaVolume ()
      {
        if (this.config.quotaVolumeSwitch)
        {
          return null
        }

        return this.config.quotaVolume
      }
    },
    quotaVisits ()
    {
      if (this.config.quotaVisitsSwitch)
      {
        return null
      }

      return this.config.quotaVisits
    },
    methods:    {
      saveForm ()
      {
        const conf       = this.config
        conf.quotaVolume = conf.quotaVolumeSwitch ? null : conf.quotaVolume
        conf.quotaVisits = conf.quotaVisitsSwitch ? null : conf.quotaVisits

        delete conf.quotaVolumeSwitch
        delete conf.quotaVisitsSwitch

        firebase
          .firestore()
          .collection('cities')
          .doc(this.cityConfig.id)
          .set(this.config, {merge: true})
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Modifications enregistrés',
            })
          })
      },

      init ()
      {
        if (!this.cityConfig)
        {
          return
        }

        // @todo find a better way to clean reactive $store prop
        this.config = JSON.parse(JSON.stringify(this.cityConfig))

        this.config.quotaVolumeSwitch = this.config.quotaVolume === null
        this.config.quotaVisitsSwitch = this.config.quotaVisits === null

        this.mounted = true
      }
    },
    watch:      {
      cityConfig ()
      {
        console.log('Config: Updated city info')
        this.init()
      }

    },
    mounted ()
    {
      console.log('Config: monuted')
      this.init()
    }
  }
</script>

<style lang="scss">
  @media print {
    .invoice-page {
      * {
        visibility: hidden;
      }

      #content-area {
        margin: 0 !important;
      }

      .vs-con-table {
        .vs-con-tbody {
          overflow: hidden !important;
        }
      }

      #invoice-container,
      #invoice-container * {
        visibility: visible;
      }

      #invoice-container {
        position: absolute;
        left: 0;
        top: 0;
        box-shadow: none;
      }
    }
  }

  @page {
    size: auto;
  }
</style>
